<template>
    <Head>
        <title>Транзакции: История</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <v-navigation/>
        </template>

        <div class="grid grid-cols-6 items-center gap-4 m-4">
            <div></div>
            <v-button color="blue" @click="day = prevDay.format('YYYY-MM-DD')">{{ prevDay.format('L') }}</v-button>
            <v-input type="date" v-model="day" />
            <v-button color="blue" v-if="`${nextDay.format('YYYY-MM-DD')}` <= `${moment().format('YYYY-MM-DD')}`"
                      @click="day = nextDay.format('YYYY-MM-DD')">{{ nextDay.format('L') }}</v-button>
            <div v-else></div>
            <div></div>
            <v-button v-show="$page.props.auth.permissions.transactions.unload_history" @click="showUnloading = !showUnloading" v-if="$page.props.auth.permissions.transactions.history">Выгрузка</v-button>
        </div>
        <div v-show="showUnloading" class="grid grid-cols-6 gap-4 m-4 items-end">
            <div class="col-span-3"></div>
            <v-input type="date" label="С числа" v-model="unloadingFrom" />
            <v-input type="date" label="По число, включительно" v-model="unloadingTo" />
            <v-button color="green" @click="unloading">Запустить</v-button>
        </div>

        <div v-if="history" class="flex flex-col bg-white relative">
            <div class="grid grid-cols-12 border-b p-2 gap-2 sticky left-0 top-0 right-0 bg-white">
                <strong class="col-span-5"></strong>
                <strong class="col-span-2 text-center">Статус</strong>
                <div class="text-right font-bold">
                    <span class="text-green-500">Приход</span> / <span class="text-red-500">Расход</span>
                </div>
                <div class="text-right font-bold">
                    <span class="text-green-500">Приход</span> / <span class="text-red-500">Расход</span>
                </div>
                <strong class="col-span-3"></strong>
                <strong>Инициатор</strong>
                <strong class="col-span-4">Адреса</strong>
                <strong class="col-span-2 text-center">Тип</strong>
                <strong class="text-right">Пользователя</strong>
                <strong class="text-right">Сервиса</strong>
                <strong class="text-center">Монета</strong>
                <strong class="text-center">Сеть</strong>
                <strong class="text-center">Дата (UTC)</strong>
            </div>

            <div class="grid grid-cols-12 p-2 gap-2 border-b items-center" v-for="h of history">
                <div class="flex flex-col">
                    <Link v-if="h.userId" :href="route('ocp.user', h.userId)"
                          class="text-xs cursor-pointer text-blue-700">
                        {{ h.userEmail }}
                    </Link>
                    <Link v-if="h.organizationId" :href="route('organization', h.organizationId)"
                          class="text-sm cursor-pointer text-blue-700">
                        {{ h.organizationName }}
                    </Link>
                    <Link v-if="h.organizationOwnerId" :href="route('ocp.user', h.organizationOwnerId)"
                          class="text-xs cursor-pointer text-blue-700">
                        {{ h.organizationOwnerEmail }}
                    </Link>
                    <span v-if="!h.userId && !h.organizationId">SERVICE</span>
                </div>
                <div class="flex flex-col break-all text-xs col-span-4 gap-1">
                    <span v-if="h.addressFrom" class="text-gray-500">Откуда</span>
                    <span>{{ h.addressFrom }}</span>
                    <span v-if="h.addressTo" class="text-gray-500">Куда</span>
                    <span>{{ h.addressTo }}</span>
                    <span v-if="h.txId" class="text-gray-500">TX ID</span>
                    <span>{{ h.txId }}</span>
                </div>
                <div class="col-span-2 flex flex-col justify-center items-center gap-1">
                    <transaction-status-icon class="h-6 w-6" v-if="h.status" :status="h.status" />
                    <span class="text-xs text-center break-all uppercase">{{ h.type }}</span>
                </div>
                <div class="text-right font-bold">
                    <span v-if="h.userArrival" class="text-green-500 whitespace-nowrap">+ {{h.userArrival}}</span>
                    <span v-else-if="h.userExpense" class="text-red-500 whitespace-nowrap">- {{h.userExpense}}</span>
                </div>
                <div class="text-right font-bold">
                    <span v-if="h.serviceArrival" class="text-green-500 whitespace-nowrap">+ {{h.serviceArrival}}</span>
                    <span v-else-if="h.serviceExpense" class="text-red-500 whitespace-nowrap">- {{h.serviceExpense}}</span>
                </div>
                <span class="text-center">{{h.coin}}</span>
                <span class="text-center">{{h.network}}</span>
                <span class="text-center">{{ moment( h.date).utc().format('L LTS') }}</span>
<!--                <pre class="col-span-full text-xs border-t">{{h}}</pre>-->
            </div>

        </div>

        <div v-else class="flex justify-center">
            <v-spinner class="h-16 w-16 mt-24"/>
        </div>

    </authenticated-layout>

</template>

<script>
import moment from "moment";
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Transactions';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import VSpinner from "@/Components/Spinner";
import TransactionStatusIcon from "@/Components/Icons/TransactionStatus";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VInput,
        VButton,
        VSelect,
        VSpinner,
        TransactionStatusIcon,
    },
    props: {
        notifications: Array,
        userId: String,
        date: String,
    },
    data () {
        return {
            showUnloading: false,
            unloadingFrom: this.date,
            unloadingTo: this.date,
            history: null,
            momentDate: moment(this.date, 'YYYY-MM-DD'),
        }
    },
    computed: {
        day: {
            set(setDate) {
                this.momentDate = moment(setDate, 'YYYY-MM-DD');
                window.location.search = `?date=${this.momentDate.format('YYYY-MM-DD')}`;
            },
            get() {
                return this.momentDate.format('YYYY-MM-DD');
            }
        },
        prevDay() {
            let date = this.momentDate.clone();
            return date.add(-1, 'days');
        },
        nextDay() {
            let date = this.momentDate.clone();
            return date.add(1, 'days');
        }
    },
    methods: {
        moment,
        get() {
            let date = this.momentDate.format('YYYY-MM-DD');
            axios.post(this.route('transactions.history.get'), {date})
                .then(res => {
                    const {success, result, notifications} = res.data;
                    if(success)
                        this.history = result;
                    this.notifications.push(...notifications);
                });
        },
        unloading() {
            const form = useForm({
                dateFrom: this.unloadingFrom,
                dateTo: this.unloadingTo,
            })
            form.post(this.route('transactions.history.unloading'));
        }
    },
    mounted() {
        this.get();
        return 1;
    }
}
</script>
